export var connectUrl = function connectUrl(authUrl, challengeId, host) {
  var url = new URL(authUrl);
  var params = url.searchParams;
  var origin = "https://".concat(host, "/challenges?cp[uuid]=").concat(challengeId);
  params.set('origin', origin);
  params.set('source', origin);
  return url.toString();
};